export const getManifestListTab = (initialFilter = {}) => ({
  field: 'preset',
  isPreset: true,
  defaultTab: 'open',
  tabs: [
    {
      key: 'open',
      label: 'Open',
      preset: {
        ...initialFilter,
        manifest_status: ['created'],
      },
    },
    {
      key: 'all',
      label: 'All',
      preset: {
        ...initialFilter,
      },
    },
  ],
});
